
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { LocationData } from '@/types/locations';
import { LoadLocations } from '@/store/modules/common-module/types';
import { AuthorizedUser } from '@/types/users';
import AdSpaceSelectItem from '@/pages/regulator/Playlist/components/AdSpacesPlaylist/AdSpaceSelectItem.vue';
import DatePickerInput from '@/ui-components/DatePickerInput/DatePickerInput.vue';
import {PlaylistAdvertiserCampaign, PlaylistCampaign, StoreOwnerCampaign} from '@/types/campaigns';
import {
  getAdSpacePlaylist,
} from '@/actions/campaigns/actions';
import PlaylistTable from '@/pages/regulator/Playlist/components/AdSpacesPlaylist/PlaylistTable.vue';
import { Nullable } from '@/types/misc';
import SkeletonLoader from '@/ui-components/SkeletonLoader/SkeletonLoader.vue';
import {getAdvertiserCompanyName, getStoreOwnersCompanyName} from '@/actions/users/actions';
import {convertCampaignTimestampsToDates, isAdvertiserCampaign, isStoreOwnerCampaign} from '@/utils/campaigns';

@Component({
  name: "AdSpacesPlaylist",
  components: { PlaylistTable, AdSpaceSelectItem, DatePickerInput, SkeletonLoader },
})
export default class AdSpacesPlaylist extends Vue {
  storeOwnerAdSpaces: LocationData[] = [];
  selectedAdSpace: Nullable<LocationData> = null;
  loadingLocations: boolean = false;
  calendarIcon = '/assets/icons/calendar.svg';
  selectedDate = '';
  loadingPlaylist: boolean = false;
  sortPlaylistByFrequency: boolean = false;
  playlistData: PlaylistCampaign[] = [];


  @Getter('locations', { namespace: namespaces.CommonModule })
  public locations!: LocationData[];

  @Getter('userInfo', { namespace: namespaces.AuthModule })
  public userInfo!: AuthorizedUser;

  @Action("loadRegulatorLocations", { namespace: namespaces.CommonModule })
  public loadRegulatorLocations!: LoadLocations;

  async created() {
    this.loadingLocations = true;
    this.storeOwnerAdSpaces = await this.loadRegulatorLocations();
    this.loadingLocations = false;
  }

  async loadPlaylistData() {
    try {
      this.loadingPlaylist = true;
      this.playlistData = await getAdSpacePlaylist(
        {
          adSpaceId: (this.selectedAdSpace as LocationData).ID,
          selectedDate: this.selectedDate,
          sortByFrequency: this.sortPlaylistByFrequency
        });
      const usersCompanyMap = await getAdvertiserCompanyName(this.playlistData);
      const storeOwnersCompanyMap = await getStoreOwnersCompanyName(this.playlistData);
      this.playlistData = this.playlistData.map(playlistCampaign => {
        if (isAdvertiserCampaign(playlistCampaign)) {
          playlistCampaign.advertiserName = usersCompanyMap[playlistCampaign.ADVERTISER_UID];
        } else if (isStoreOwnerCampaign(playlistCampaign)) {
          (playlistCampaign as StoreOwnerCampaign).storeOwnerCompanyName = storeOwnersCompanyMap[playlistCampaign.STORE_OWNER_UID];
        }
        return convertCampaignTimestampsToDates(playlistCampaign);
      })
    } catch (e) {
      console.log('loadPlaylistData Error:', e)
    } finally {
      this.loadingPlaylist = false;
    }
  }


  @Watch('selectedDate')
  onDateChanged() {
    if (this.selectedAdSpace) {
      this.loadPlaylistData();
    }
  }

  @Watch('selectedAdSpace')
  onAdSpaceChange() {
    if (this.selectedDate) {
      this.loadPlaylistData();
    }
  }

  @Watch('sortPlaylistByFrequency')
  sortPlaylistByFrequencyChanged() {
    this.loadPlaylistData();
  }
}
